import { useCallback } from "react"
import {
	IconArrowRotateAnticlockwiseOutline18 as Restore,
	IconTrashOutline18 as Trash,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { IconButton, Tooltip } from "@productlane/ui"
import { mutators } from "@productlane/zero/mutators"

import { toast } from "@/components/toast"
import { analytics } from "@/lib/analytics"
import { mutateOk, useZero } from "@/lib/zero"
import { useThreadContext } from "../../thread-context"
import { THREAD_COLUMN_PADDING } from "./thread-column"

export const ThreadDeletedBanner = () => {
	const { thread } = useThreadContext()
	const zero = useZero()

	const handleRestore = useCallback(async () => {
		await mutateOk(
			zero.mutate(
				mutators.threads.restore({
					id: thread.id,
				}),
			),
		)
		analytics.track("restore-thread", { threadId: thread.id })
		toast.success({
			title: "Thread restored",
			icon: Restore,
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [thread.id, zero.mutate])

	return (
		<div
			className={cn("mx-auto w-full max-w-[50rem] pt-3", THREAD_COLUMN_PADDING)}
		>
			<div className="flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-3 py-1.5 dark:border-gray-700/80 dark:bg-gray-800/50">
				<div className="flex min-w-0 flex-1 items-center gap-2 text-sm text-secondary">
					<Trash className="h-3.5 w-3.5 shrink-0" />
					<span className="truncate font-medium">Thread deleted</span>
				</div>
				<div className="flex shrink-0 items-center gap-0.5">
					<Tooltip label="Restore thread" shouldWrapChildren>
						<IconButton
							Icon={Restore}
							variant="ghost"
							size="sm"
							aria-label="Restore thread"
							onClick={() => void handleRestore()}
						/>
					</Tooltip>
				</div>
			</div>
		</div>
	)
}
